import React from 'react'
import { withRouter, RouteComponentProps } from 'react-router-dom'

import { Centre as CentreType } from '../../../../../types/centre'
import { CentreSelector as SharedCentreSelector } from '../../../centre-selector'
import headerStyles from '../index.scss'
import navStyle from './index.scss'

const style = { ...headerStyles, ...navStyle }

export const CentreSelector = withRouter(
  ({
    centres,
    centre: currentCentre,
  }: RouteComponentProps & { centres: CentreType[]; centre?: CentreType }) => (
    <SharedCentreSelector
      centres={centres}
      centre={currentCentre}
      navStyle={style}
    />
  )
)
